export default __webpack_public_path__ + "static/media/drinkoFarmImageTwo.602c3cc3.png";